import {
  ALIAS_FIELD,
  BIRTH_PLACE_FIELD,
  BIRTHDATE_FIELD,
  COMMENTS_FIELD,
  DATE_DECEASED_FIELD,
  EMAIL_FIELD,
  EMPLOYER_NAME_FIELD,
  FIRST_NAME_FIELD,
  GENDER_FIELD,
  ID_NUMBER_FIELD,
  IS_DECEASED_FIELD,
  LAST_NAME_FIELD,
  MIDDLE_NAME_FIELD,
  MOTHERS_NAME_FIELD,
  NATIONALITY1_FIELD,
  NATIONALITY2_FIELD,
  NATIONALITY3_FIELD,
  OCCUPATION_FIELD,
  PASSPORT_COUNTRY,
  PASSPORT_NUMBER_FIELD,
  RESIDENCE_FIELD,
  SOURCE_OF_WEALTH_FIELD,
  SSN_FIELD,
  TAX_NUMBER_FIELD,
  TAX_REG_NUMBER_FIELD,
  TITLE_FIELD,
} from 'app/modules/goAML/schemas/tPersonSchema';

/** XSD t_person_registration_in_report: commonly filled reporting-agent fields. */
export const T_PERSON_REGISTRATION_CORE_FIELDS = [
  GENDER_FIELD,
  TITLE_FIELD,
  FIRST_NAME_FIELD,
  MIDDLE_NAME_FIELD,
  LAST_NAME_FIELD,
  BIRTHDATE_FIELD,
  BIRTH_PLACE_FIELD,
  SSN_FIELD,
  PASSPORT_NUMBER_FIELD,
  PASSPORT_COUNTRY,
  ID_NUMBER_FIELD,
  NATIONALITY1_FIELD,
  NATIONALITY2_FIELD,
  NATIONALITY3_FIELD,
  RESIDENCE_FIELD,
  EMAIL_FIELD,
  OCCUPATION_FIELD,
  EMPLOYER_NAME_FIELD,
];

/** XSD t_person_registration_in_report: optional / rarely used fields. */
export const T_PERSON_REGISTRATION_OPTIONAL_FIELDS = [
  MOTHERS_NAME_FIELD,
  ALIAS_FIELD,
  IS_DECEASED_FIELD,
  DATE_DECEASED_FIELD,
  TAX_NUMBER_FIELD,
  TAX_REG_NUMBER_FIELD,
  SOURCE_OF_WEALTH_FIELD,
  COMMENTS_FIELD,
];

export const T_PERSON_REGISTRATION_RAW_INPUTS_SCHEMA = [
  ...T_PERSON_REGISTRATION_CORE_FIELDS,
  ...T_PERSON_REGISTRATION_OPTIONAL_FIELDS,
];
